__turbopack_context__.v({
  "hostInformation": "_1r2idW_hostInformation",
  "modalBody": "_1r2idW_modalBody",
  "modalContent": "_1r2idW_modalContent",
});
